import React, { useState } from 'react';
import { useT } from '../../i18n/useT';
import './FAQAccordion.css';

// Kept for any lingering imports — use t.faqs directly instead
export const ALL_FAQS = [];

export default function FAQAccordion({ items, limit }) {
  const [openIndex, setOpenIndex] = useState(null);
  const t = useT();

  // Accept pre-filtered items (passed from FAQPage), or show all translated FAQs
  const source = (items && items.length > 0) ? items : t.faqs;
  const displayItems = limit ? source.slice(0, limit) : source;

  return (
    <div className="faq-accordion" role="list">
      {displayItems.map((faq, i) => (
        <div
          key={i}
          className={`faq-accordion__item ${openIndex === i ? 'faq-accordion__item--open' : ''}`}
          role="listitem"
        >
          <button
            className="faq-accordion__question"
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
            aria-expanded={openIndex === i}
            id={`faq-q-${i}`}
            aria-controls={`faq-a-${i}`}
          >
            <span>{faq.question}</span>
            <div className="faq-accordion__chevron" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </button>
          <div
            className="faq-accordion__answer"
            id={`faq-a-${i}`}
            role="region"
            aria-labelledby={`faq-q-${i}`}
          >
            <div className="faq-accordion__answer-inner">
              <p>{faq.answer}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
